const Events = {
    dispatch: (eventName, data = []) => {
        $(document).trigger(eventName, data);
    },
    listen: (eventName, callback) => {
        $(document).on(eventName, callback);
    }
}
